export class AlreadyAnnouncedSamplesDTO {
    plateID: string;
    barCode: string;
    position: string;
    storagePosition: string;
}